import React, { FC, memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RouteComponentProps, useParams } from 'react-router-dom'

import { selectors } from '../../redux'
import { Screen } from '../../types/global'
import AppointementPage from '../Appointement'
import DisclaimerPage from '../Disclaimer'
import MessagePage from '../Message'
import ConfirmationPage from '../Confirmation'
import i18n from '../../i18n'

const RootContainer: FC<RouteComponentProps> = () => {
  const screen = useSelector(selectors.app.screen)
  const routerParams = useParams<{ locale?: string }>()

  const [languageSet, setLanguageSet] = useState(false)

  useEffect(() => {
    console.log('useeffect')
    i18n.changeLanguage(routerParams.locale).then(() => {
      console.log('language set')
      setLanguageSet(true)
    })
  }, [routerParams.locale])

  if (!languageSet) {
    return null
  }

  return (
    <>
      {screen === Screen.appointement && <AppointementPage />}
      {screen === Screen.disclaimer && <DisclaimerPage />}
      {screen === Screen.message && <MessagePage />}
      {screen === Screen.confirmation && <ConfirmationPage />}
    </>
  )
}

export default memo(RootContainer)
